module.exports = __webpack_public_path__ + "static/media/iconportalDODlogo.721855ef1261ee113275c08ae37a350a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iconportalDODlogo.png
// module id = 2500
// module chunks = 1